"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRTL = exports.isSSR = exports.isMobile = exports.getSiteLanguage = void 0;
var constants_1 = require("./constants");
var utils_1 = require("./utils");
exports.getSiteLanguage = function (wixCodeApi, fallbackLanguage) {
    if (fallbackLanguage === void 0) { fallbackLanguage = 'en'; }
    var multilingualLanguage = utils_1.getMultilingualLanguage(wixCodeApi.window.multilingual);
    // NOTE: language can be null (see WEED-18001)
    return multilingualLanguage || wixCodeApi.site.language || fallbackLanguage;
};
exports.isMobile = function (wixCodeApi) {
    return wixCodeApi.window.formFactor === 'Mobile';
};
exports.isSSR = function (wixCodeApi) {
    return wixCodeApi.window.rendering.env === 'backend';
};
exports.isRTL = function (language) { return constants_1.RTL_LANGUAGES.includes(language); };
//# sourceMappingURL=helpers.js.map